import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '@maxus/website/hooks'
import { resolveReturnTo } from '@maxus/website/utils'

import { GlobalSpinner } from './global-spinner'

// 反向守卫：已登录访问 /login 自动跳走（回 ?redirect 站内路径，缺省 /）
export const RedirectIfAuthed: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { status } = useAuth()
  const location = useLocation()

  if (status === 'loading') return <GlobalSpinner />
  if (status === 'authed') return <Navigate to={resolveReturnTo(location.search)} replace />
  return <>{children}</>
}
